import { formatDateForHash, getHashObj, getSasonBasedOnDate, parseHashParams } from "@/utils/utils";
import getFirstAvailableResponse from "@/vue/planning/logic/getFirstAvailableResponse"
import isHaveAvailability from "@/vue/planning/logic/isHaveAvailability"
import { AvailabilitiesResponse } from "@/types/responses";
import packConfig from "@/config/packConfig"
import store from "@/vue/planning/store/store"
import { getAvailablePackagesWiyp } from "./availablesPackagesWiyp";
import { isSameTrainPackageType, resolveTrainPackCodeForOrigin } from "@/config/trainPackageConfig"
import _ from "lodash";

const getHashPackCode = (): string | undefined => {
    const hash = window.location.hash.replace("#", "")
    const hashObj = getHashObj(hash) as {[key: string]: string}
    const hashPackCode: string | undefined = hashObj.packCode
    return hashPackCode
}

const ensureValidPackCodeIsSelected = (avail_resp: AvailabilitiesResponse, dispatch: any) => {
    const hashPackCode: string | undefined = getHashPackCode()
    const hashOrigin = (() => {
        const hash = window.location.hash.replace("#", "")
        const hashObj = getHashObj(hash) as {[key: string]: string}
        return hashObj.origin?.split("-")[0] || store.state.flightOrigin?.split("-")[0] || ""
    })()
    const resolvedHashPack = hashPackCode
        ? resolveTrainPackCodeForOrigin(hashPackCode, hashOrigin)
        : undefined

    const hashPackIsAvailable = !!(hashPackCode || resolvedHashPack) && store.state.availablePackageCodeWiyp.some(p =>
        p.codePackage === hashPackCode ||
        p.codePackage === resolvedHashPack ||
        (hashPackCode && isSameTrainPackageType(p.codePackage, hashPackCode)) ||
        (resolvedHashPack && isSameTrainPackageType(p.codePackage, resolvedHashPack))
    )

    if(!hashPackIsAvailable) {
        let wasPackageSet = false
        for(const priorityPackCode of packConfig) {
            if(store.state.availablePackageCodeWiyp.find(p => p.codePackage === priorityPackCode)) {
                dispatch("setPackage", priorityPackCode)
                wasPackageSet = true
                break
            }
        }
        if(!wasPackageSet) {
            dispatch("setPackage", avail_resp?.codePack) 
        }
    } else if (resolvedHashPack && resolvedHashPack !== store.state.packCode) {
        dispatch("setPackage", resolvedHashPack)
    }
}

const makeInitialAvailRequest = async (store: any) => {
    const { state, commit, dispatch } = store

    const hashPackCode: string | undefined = getHashPackCode()
    let avail_resp = await getFirstAvailableResponse(store, hashPackCode)

    // Check if we need to switch season based on dates
    if (avail_resp?.endDates?.startDate) {
        const seasonBasedOnDate = getSasonBasedOnDate(avail_resp.endDates.startDate)

        if (seasonBasedOnDate !== state.season) {
            commit("setSeason", seasonBasedOnDate)
            window.seasonManager.switchSeasonWithoutReloading()
            avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        }
    }

    // If still no availability - try switching seasons
    if (!isHaveAvailability(avail_resp)) {
        const newSeason = state.season === "E" ? "H" : "E"
        commit("setSeason", newSeason)
        window.seasonManager.switchSeasonWithoutReloading()

        // Try again with new season
        avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        
        // If still no availability, try one more time with the original season
        if (!isHaveAvailability(avail_resp)) {
            commit("setSeason", state.season === "E" ? "H" : "E")
            window.seasonManager.switchSeasonWithoutReloading()
            avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        }
    }

    if (!isHaveAvailability(avail_resp)) {
        commit("setProductUnavailable", true)
        dispatch("setLoading", false)
        return
    }

    // set packCode if it was empty, or it's not available
    ensureValidPackCodeIsSelected(avail_resp, dispatch)

    // set dates from response if url doesnt have them
    if (Object.keys(state.dates).length === 0) {
        const newDates = {
            "BeginDate": formatDateForHash(avail_resp?.endDates?.startDate),
            "EndDate": formatDateForHash(avail_resp?.endDates?.endDate),
        };
        dispatch("setDates", newDates)
    }

    // Keep the hash/state pack when it is already valid. Merged related-package
    // responses can have a different codePack (or a corrupted array if strings were spread).
    const responsePackCode = Array.isArray(avail_resp.codePack)
        ? avail_resp.codePack.find((code: string) => typeof code === "string" && code.length > 1)
        : avail_resp.codePack
    if (!state.packCode && responsePackCode) {
        dispatch("setPackage", responsePackCode)
    }

    return avail_resp
}

export default makeInitialAvailRequest